import { push } from "connected-react-router";
import { db } from "../../firebase/index";
import { FirebaseTimestamp } from "../../firebase";
import { inputInquiry } from './actions';

export const setInquiry = (name, email, content, createdAt) => {
    return async (dispatch) => {
        dispatch(inputInquiry({
            name: name,
            email: email,
            content: content,
            createdAt: createdAt,
        }))

        if ( (name !== "") && (email !== "") && (content !== "") ) {
            // 完了ページ or 完了ダイアログを表示
        }else{
            window.alert("必須項目が未入力です")
        }
    }
}


export const registerInquiry = (name, email, content) => {
    return async (dispatch) => {
        // validation
        if( name === "" || email === "" || content === "" ) {
                window.alert("必須項目が未入力です")
                return false
        }

        const createdAt = FirebaseTimestamp.now()
        
        const inquiryData = {
            name: name,
            email: email,
            content: content,
            createdAt: createdAt,
        }

        db.collection('Inquiries').doc().set(inquiryData)
            .then(() => {
                dispatch(push('/inquiry-completed'));
            })
    }
}